<div [class.wrapper]= "currentUser && !showLogin"  >
  <app-weblink-header (onChangeUser)="changeUser()"></app-weblink-header>

  <div *ngIf="isLoading">
      <!-- <app-weblink-header></app-weblink-header> -->
      <app-weblink-loader></app-weblink-loader>
  </div>

  <span *ngIf="!hasToken && !isLoading">
    <!-- <app-weblink-header></app-weblink-header> -->
    <h4>Verwenden Sie Ihren weblink, um die Anwendung zu starten!</h4>
  </span>
  <span *ngIf="hasToken && !hasValidToken && !isLoading">
    <!-- <app-weblink-header></app-weblink-header> -->
    <b>{{ tokenValidToMessage }}</b>
  </span>
  <div *ngIf="hasToken && hasValidToken && !isLoading">
    <app-weblink-login *ngIf="!currentUser || showLogin"></app-weblink-login>
    <app-weblink-fault-list  (onChangeUser)="changeUser()" [class.hidden]="!currentUser || showLogin" ></app-weblink-fault-list>
  </div>
</div>
<app-weblink-footer></app-weblink-footer>

